module.exports = "<ng-content *ngIf=\"isBus\" select=\".bus\"></ng-content>\n<ng-content *ngIf=\"isShip\" select=\".ship\"></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/by-site-type/by-site-type.component.html
// module id = ./src/app/shared/components/by-site-type/by-site-type.component.html
// module chunks = main